import { useContext } from "react";
import { Users } from "lucide-react";
import { ContainerActions, ContainerLeads, ContainerPageNavigation, ContainerSearch } from ".";
import { SidebarContext } from "../../../shared/context/SidebarContext";
import { LeadsContext } from "../context/LeadsContext";
import { ModalAddTagsBulk, ModalCreateLead, ModalEditLead, ModalExportLeads, ModalImportLeads, ModalPurchaseLead, ModalRemoveTagsBulk, ModalTagsLead } from "./modals";


export default function Main() {

    const { isOpen } = useContext(SidebarContext);
    const { isOpenModalAddTagsBulk } = useContext(LeadsContext);
    const { isOpenModalPurchases } = useContext(LeadsContext);
    const { isOpenModalRemoveTagsBulk } = useContext(LeadsContext);
    const { isOpenModalEditLead } = useContext(LeadsContext);
    const { isOpenModalCreateLead } = useContext(LeadsContext);
    const { isOpenModalImport } = useContext(LeadsContext);
    const { isOpenModalTags } = useContext(LeadsContext);
    const { isOpenModalExport } = useContext(LeadsContext);


    return (
        <div className="min-h-screen text-ink-1 flex relative z-0">
            <div className={`transition-all duration-300 ease-out-expo ${isOpen ? "lg:ml-64" : "sm:ml-16"} w-full max-w-full mb-16 sm:mb-0`}>

                <div className="px-5 sm:px-8 pt-8 pb-12 max-w-[1600px] mx-auto">

                    <header className="mb-8 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 animate-fade-in">
                        <div className="space-y-1">
                            <span className="label-overline">Base</span>
                            <h1 className="display-2 flex items-center gap-3">
                                Leads
                                <Users className="h-7 w-7 text-brand-400" strokeWidth={2.2} />
                            </h1>
                            <p className="text-ink-3 text-sm">
                                Gerencie sua base de contatos, importe leads e segmente com tags.
                            </p>
                        </div>
                        <ContainerActions />
                    </header>

                    <ContainerSearch />
                    <ContainerLeads />
                    <ContainerPageNavigation />

                </div>

                {isOpenModalCreateLead && <ModalCreateLead />}
                {isOpenModalEditLead && <ModalEditLead />}
                {isOpenModalImport && <ModalImportLeads />}
                {isOpenModalTags && <ModalTagsLead />}
                {isOpenModalExport && <ModalExportLeads />}
                {isOpenModalPurchases && <ModalPurchaseLead />}
                {isOpenModalAddTagsBulk && <ModalAddTagsBulk />}
                {isOpenModalRemoveTagsBulk && <ModalRemoveTagsBulk />}
            </div>
        </div>
    );
}
